/** /support/:ref. The ticket workspace, keyed by ELU-XXXXX or the numeric id. */
import { createRoute } from '@tanstack/react-router';
import { Route as shellRoute } from '../_shell';
import { useSession } from '@/app/session';
import { TicketWorkspace } from '@/features/support/TicketWorkspace';

function TicketPage() {
  const { ref } = Route.useParams();
  const { role } = useSession();
  return <TicketWorkspace ticketRef={ref} role={role ?? 'agent'} />;
}

export const Route = createRoute({
  getParentRoute: () => shellRoute,
  path: '/support/$ref',
  component: TicketPage,
});
